import { Controller } from '@hotwired/stimulus'
import { loadTurboFrame } from 'helpers/turbo_frames'

export default class extends Controller {
  static targets = ['dialogContent', 'frame']
  static outlets = ['ui--modal--dialog']

  DIALOG_ID = 'modal-dialog-singleton'
  DIALOG_OPEN_CLASS = 'gds--modal__dialog--open'
  DIALOG_CONTROLLER = 'ui--modal--dialog'

  connect() {
    // needed here in case frame is loaded before modal opens
    this.element.addEventListener('turbo:frame-load', this.uiModalDialogOutlet.handleFrameLoad)
    this.element.addEventListener('modal:open', this.handleOpen)
    this.element.addEventListener('galette:setFrameSrc', this.handleSetFrameSrc)
  }

  disconnect() {
    if (this.hasUiModalDialogOutlet) {
      this.element.removeEventListener('turbo:frame-load', this.uiModalDialogOutlet.handleFrameLoad)
    }
    this.element.removeEventListener('modal:open', this.handleOpen)
  }

  isOpen = () => {
    return this.uiModalDialogOutlet.modalController === this
  }

  handleOpen = () => {
    this.uiModalDialogOutlet.open(this)
  }

  handleSetFrameSrc = ({ detail: { src } }) => {
    if (this.isOpen()) {
      // modal is open, frame target attached to dialog
      loadTurboFrame(this.uiModalDialogOutlet.frameTarget, src)
    } else {
      if (!this.hasFrameTarget) {
        throw `Could not find frame within modal container #${this.element.id}!`
      }
      loadTurboFrame(this.frameTarget, src)
    }
  }
}
